import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

import { StoryCard } from "@/components/StoryCard";
import { VerticalVideoFrame } from "@/components/VerticalVideoFrame";
import { Button } from "@/components/ui/button";
import { usePageSeo } from "@/hooks/usePageSeo";
import { LOCATION_HUB_CONFIG, getLocationHubStories } from "@/utils/newsroomCollections";

export const LocationHubPage = ({ feed, hubKey }) => {
  const hub = LOCATION_HUB_CONFIG[hubKey];
  const stories = getLocationHubStories(feed, hubKey);
  const featuredStory = stories[0];

  usePageSeo({
    canonicalPath: hub.route,
    description: hub.description,
    title: `${hub.title} | Content Watch HQ`,
  });

  return (
    <main className="page-shell mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid={`location-hub-page-${hub.key}`}>
      <section className="grid gap-8 border border-[#D9DCE1] bg-white p-6 lg:grid-cols-[minmax(0,1fr)_320px] lg:p-8" data-testid={`location-hub-hero-${hub.key}`}>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#D21404]">Authority hub</p>
          <h1 className="mt-3 font-[Bebas_Neue] text-5xl uppercase tracking-[0.04em] text-[#0A0A0A] sm:text-6xl" data-testid={`location-hub-title-${hub.key}`}>{hub.title}</h1>
          <p className="mt-4 max-w-3xl text-base leading-8 text-slate-700" data-testid={`location-hub-description-${hub.key}`}>{hub.description}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button asChild className="rounded-none bg-[#1338BE] px-5 py-5 text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#102F9B]" data-testid={`location-hub-home-button-${hub.key}`}>
              <Link to="/">
                Back Home
                <ArrowRight size={16} weight="bold" />
              </Link>
            </Button>
          </div>
        </div>
        {featuredStory ? <VerticalVideoFrame compact story={featuredStory} /> : (
          <div className="border border-[#D9DCE1] bg-[#F8F9FA] p-6" data-testid={`location-hub-empty-hero-${hub.key}`}>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#D21404]">Coverage coming soon</p>
            <p className="mt-3 text-sm leading-7 text-slate-700">This hub stays minimal until verified local reporting is live. We are no longer filling it with placeholder out-of-market content.</p>
          </div>
        )}
      </section>

      <section className="news-card-grid mt-8" data-testid={`location-hub-grid-${hub.key}`}>
        {stories.length ? stories.map((story) => <StoryCard key={story.id || story.slug} story={story} />) : (
          <div className="border border-[#D9DCE1] bg-white p-8 md:col-span-2 xl:col-span-3" data-testid={`location-hub-empty-state-${hub.key}`}>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#D21404]">Coverage coming soon</p>
            <p className="mt-3 text-base leading-8 text-slate-700">We are only showing verified local reporting here. Placeholder city content and stock stand-ins have been removed until a live local source is available.</p>
          </div>
        )}
      </section>
    </main>
  );
};